import { PaginationDetails } from "./api_request";

export interface ScheduleCreateProps {
  schedule_name: string;
  description: string;
  start_date: string;
  end_date: string;
}

export interface ScheduleContentsProps {
  scheduleList: ScheduleData[];
  loading: boolean;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  viewMode: boolean;
  setFilterData:   React.Dispatch<React.SetStateAction<string>>;
  paginationState: PaginationDetails;
  setPaginationState:   React.Dispatch<React.SetStateAction<PaginationDetails>>;
  setViewMode: () => void;
}

export interface ScheduleContentsTablePropTypes {
  scheduleList:  ScheduleData[];
  loading: boolean;}

export interface ScheduleContentsTableProps {
  scheduleList:  ScheduleData[];
  loading: boolean;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  setFilterData:   React.Dispatch<React.SetStateAction<string>>;
  paginationState: PaginationDetails;
  setPaginationState:   React.Dispatch<React.SetStateAction<PaginationDetails>>;
}

export interface ScheduleData {
  created_at: string;
  description: string;
  end_date: string;
  facility: string;
  schedule_name: string;
  start_date: string;
  shifts: Shift[];
  status: string;
  updated_at: string;
  _id: string;
}

export const ScheduleDummyData = {
  created_at: "",
  description: "",
  end_date: "",
  facility: "",
  schedule_name: "",
  start_date: "",
  status: "",
  shifts: [],
  updated_at: "",
  _id: "",
};

export interface ScheduleBoxProps {
  shift: string;
  time: string;
  days: string;
}

export interface CalendarScheduleList {
  scheduleList: ScheduleData[];
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;

}

export interface ShiftCreateProps {
  schedule_id: string;
  employee_id: string;
  start_time: string;
  end_time: string;
}

export interface Shift {
  schedule_id: string;
  employee_id: string;
  start_time: string;
  end_time: string;
  assigned_to: any;
}
